import { UserStatus, FuelCategoryEnum, ProductCodeEnum } from "enums";

export const prettifyReportType = (type) => {
  return (
    {
      "price-buildup": "Price Build-Up",
    }[type] || type
  );
};

export const prettifyUserStatus = (type) => {
  return (
    {
      [UserStatus.Active]: "Active",
      [UserStatus.Deactivated]: "Deactivated",
      [UserStatus.Deleted]: "Deleted",
    }[type] || ""
  );
};

export const prettifyFuelCategory = (type) => {
  return (
    {
      [FuelCategoryEnum.GASOLINE]: "Gasoline",
      [FuelCategoryEnum.DIESEL]: "Diesel",
      [FuelCategoryEnum.KEROSENE]: "Kerosene",
      [FuelCategoryEnum.LPG]: "LPG",
    }[type] || ""
  );
};

export const prettifyProductCode = (type) => {
  return (
    {
      [ProductCodeEnum.DIESEL]: "Diesel",
      [ProductCodeEnum.GAS91]: "Extreme U",
      [ProductCodeEnum.GAS95]: "Extreme 95",
      [ProductCodeEnum.GAS97]: "Extreme 97",
      [ProductCodeEnum.GAS105]: "Extreme 105",
      [ProductCodeEnum.GAS105]: "Extreme 105",
      [ProductCodeEnum.KEROSENE]: "Kerosene",
      [ProductCodeEnum.LPG]: "LPG",
    }[type] || ""
  );
};

export const prettifyProductCodeColor = (type) => {
  return (
    {
      [ProductCodeEnum.DIESEL]: "#fcad0a",
      [ProductCodeEnum.GAS91]: "#078162",
      [ProductCodeEnum.GAS95]: "#ee3b34",
      [ProductCodeEnum.GAS97]: "#2e4491",
      [ProductCodeEnum.GAS105]: "#7b5ea7",
      [ProductCodeEnum.KEROSENE]: "#ffffff",
      [ProductCodeEnum.LPG]: "#87ceeb",
    }[type] || ""
  );
};

export const prettifyProductCodeStyle = (type) => {
  const bg = prettifyProductCodeColor(type);
  const style = { backgroundColor: bg };
  if (type === ProductCodeEnum.KEROSENE) {
    style.border = "1.5px solid #333333";
  }
  return style;
};
